<template>
    <ui-modal
        name="contracts-edit-tasks"
        :title="titleModal"
        icon="fal fa-calendar-alt"
        size="xs"
    >
        <div class="ui-facilita-register">
            <section class="ui-facilita-register-tasks">
                <section class="ui-facilita-register-tasks-content">
                    <ui-select-2
                        v-model="form.data.type"
                        item-label="label"
                        return-value="value"
                        placeholder="Selecione"
                        label="Tipo:"
                        :search="false"
                        :data="typeOptions"
                        :show-footer="false"
                        :loading="loader.typeLoad"
                    />

                    <ui-input v-model="form.data.title" label="Título:" type="text" size="md" />

                    <div class="time-values">
                        <div class="time-value date">
                            <ui-datepicker
                                v-model="form.data.for_date"
                                groupicon="fal fa-calendar-alt"
                                type="date"
                                label="Data:"
                                :context="'today'"
                            />
                        </div>

                        <div class="time-value time">
                            <ui-input
                                v-model="form.data.for_hour"
                                groupicon="fal fa-clock"
                                type="time"
                                label="Hora:"
                                design="time-md"
                            />
                        </div>
                    </div>

                    <ui-textarea
                        v-model="form.data.notes"
                        placeholder="Digite..."
                        label="Descrição:"
                        rows="3"
                    />
                </section>
            </section>
        </div>
        <template #footer>
            <div class="cancel-buttons">
                <ui-button :track-event="gtm.cancel" type="button" design="md link cancel-button" @click="closeModal">
                    Cancelar
                </ui-button>
            </div>
            <ui-button
                type="button"
                design="md success mw-100"
                :loading="loader.loadSaveButton"
                :disabled="!canSubmit"
                @click="submit"
            >
                Atualizar
            </ui-button>
        </template>
    </ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiSelect2, uiInput, uiDatepicker, uiTextarea } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'

	import { task } from '@/services/axios'

	import { helpersMixin, loaderMixin, alertMixin, utilMixin } from '@/mixins'

	import { defaultGtm } from './default'

	const defaultData = {
		title: '',
		notes: '',
		type: null,
		for_date: null,
		for_hour: null
	}

	const defaultLoader = {
		typeLoad: false,
		loadSaveButton: false
	}
	export default {
		name: 'modal-edit-tasks',

		components: {
			uiModal,
			uiSelect2,
			uiInput,
			uiDatepicker,
			uiTextarea,
			uiButton
		},

		mixins: [helpersMixin, loaderMixin, alertMixin, utilMixin],

		data() {
			return {
				form: {
					data: { ...defaultData },
				},
				loader: { ...defaultLoader },
				typeOptions: [],
				gtm: { ...defaultGtm() },
				cardId: null,
				customerName: ''
			}
		},

		computed: {
			getCardId() {
				return this.cardId
			},

			titleModal() {
				const id = this.cardId ? ' – #' + this.cardId : ''
				return 'Atualizar Tarefa' + id
			},

			hasAHistorical() {
				let form = this.form.data
				return form.title &&
					this.$mx_hasValue(form.type) &&
					form.for_date
			},

			/**
				* Condicional que permite o envio do formulário.
				*/
			canSubmit() {
				return (this.hasAHistorical)
			},

			validateDealFormData() {
				let form = this.form.data
				let formData = {
					type: form.type,
					notes: form.notes,
					title: form.title,
					for_date: form.for_date,
					for_hour: form.for_hour
				}

				return formData
			}
		},

		watch: {
			'form.data.type'(newVal) {
				switch (newVal) {
					case 'chat':
						this.form.data.title = `Chat com ${this.customerName}`
					break
					case 'mail':
						this.form.data.title = `Enviar e-mail para ${this.customerName}`
					break
					case 'call':
						this.form.data.title = `Fazer ligação para ${this.customerName}`
					break
					case 'observation':
						this.form.data.title = `Observações para ${this.customerName}`
					break
					case 'proposal':
						this.form.data.title = `Fazer proposta para ${this.customerName}`
					break
					case 'visit':
						this.form.data.title = `Visitar ${this.customerName}`
					break
					case 'whatsapp':
						this.form.data.title = `Enviar mensagem no WhatsApp para ${this.customerName}`
					break
					default:
						this.form.data.title = ''
				}
			}
		},

		async mounted() {
			this.$root.$on('modal-open-contracts-edit-tasks', () => {
				this.openIframe('closed-modal')
			})
			this.cardId = Number(this.$route.params.dealId)

			await this.setForm(this.cardId)

			await this.loadForm()

			this.$root.$on('modal-close-contracts-edit-tasks', () => {
				window.parent.postMessage({ event: 'modalEditTasksClosed', dataForm: this.form.data }, '*')

				this.close()
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-contracts-edit-tasks')
			this.$root.$off('modal-close-contracts-edit-tasks')
		},

		methods: {
			async loadForm() {
				if (!this.typeOptions.length) {
					this.$mx_setLoader('typeLoad', true)
					const response = await task.getAll('types', null)
					this.typeOptions = response.data[0].fields
					this.$mx_setLoader('typeLoad', false)
				}
			},

			close() {
				const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
			},

			openIframe(value, data = null) {
				let event = new CustomEvent(`iframe--contracts-${value}`, { detail: data })
				window.parent.document.dispatchEvent(event)
			},

			closeModal() {
				this.$root.$emit('modal-close-contracts-edit-tasks')

				if (this.fullPage) this.$router.go(-1)
			},

			async setForm(cardId) {
				try {
					const { data } = await task.get('', cardId)
					this.form.data.for_hour = this.formatForHour(data.for_hour)
					this.form.data = data
					this.customerName = data.linked.deal.customer.name
				} catch (error) {
					this.$mx_alertThisOnError(error)
				}
			},

			formatForHour(hour) {
				// Pegar os primeiros 5 caracteres e adicionar ":00" ao final
				return hour ? hour.substring(0, 5) : ''
			},

			async submit() {
				if (!this.canSubmit) return
				this.loader.loadSaveButton = true

				try {
					const response = await task.update('', this.cardId, this.validateDealFormData)
					this.loader.loadSaveButton = false

					this.$mx_alertSuccess(response.data.msg)

					setInterval(() => {
						this.closeModal()
					}, 1500)
				} catch(error) {
					this.$mx_alertThisOnError(error)
					this.loader.loadSaveButton = false
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>
